import React from "react";
import { Box, Card } from "common";
import { useStyles } from "./MyProfile.style";
import COLORS from "common/Theme/colors";
import { AccountDetails } from "./AccountDetails";

const ProfileDetails = ({
  name,
  email,
  role,
}: {
  name: string;
  email: string;
  role: string;
}) => {
  const { profileDetailContainer } = useStyles();
  return (
    <Card
      padding={4}
      borderRadius="8px"
      border={`1px solid ${COLORS.LIGHT_GRAY}`}
      marginY="20px"
    >
      <Box className={profileDetailContainer}>
        <AccountDetails heading="Name" subheading={name} />
        <AccountDetails heading="Email Address" subheading={email} />
        <AccountDetails heading="Access type" subheading={role} />
      </Box>
    </Card>
  );
};

export default ProfileDetails;
